import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "variabletypes"
    }}>{`VariableTypes`}</h1>
    <p>{`Text variable types.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CUSTOM_TEXT_TYPE`}</strong>{` = 1414947700`}</p>
      <p parentName="blockquote">{`Custom text variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FILE_NAME_TYPE`}</strong>{` = 1414948462`}</p>
      <p parentName="blockquote">{`File name variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LAST_PAGE_NUMBER_TYPE`}</strong>{` = 1414952048`}</p>
      <p parentName="blockquote">{`Last page number variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHAPTER_NUMBER_TYPE`}</strong>{` = 1668183152`}</p>
      <p parentName="blockquote">{`Chapter number variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OUTPUT_DATE_TYPE`}</strong>{` = 1414950756`}</p>
      <p parentName="blockquote">{`Output date variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CREATION_DATE_TYPE`}</strong>{` = 1414947684`}</p>
      <p parentName="blockquote">{`Creation date variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MODIFICATION_DATE_TYPE`}</strong>{` = 1414950244`}</p>
      <p parentName="blockquote">{`Modification date variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MATCH_CHARACTER_STYLE_TYPE`}</strong>{` = 1414947667`}</p>
      <p parentName="blockquote">{`Running header (character style) variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MATCH_PARAGRAPH_STYLE_TYPE`}</strong>{` = 1414950995`}</p>
      <p parentName="blockquote">{`Running header (paragraph style) variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`XREF_PAGE_NUMBER_TYPE`}</strong>{` = 1414953074`}</p>
      <p parentName="blockquote">{`Private cross reference page number variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`XREF_CHAPTER_NUMBER_TYPE`}</strong>{` = 1414947694`}</p>
      <p parentName="blockquote">{`Private cross reference chapter number variable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LIVE_CAPTION_TYPE`}</strong>{` = 1414947693`}</p>
      <p parentName="blockquote">{`Live Caption variable.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      